import React, { createContext, useState, FC, ReactNode } from 'react';

export interface ISearchContextProps {
    searchQuery: string;
    setSearchQuery: (query: string) => void;
}

const SearchContext = createContext<ISearchContextProps>({
    searchQuery: '',
    setSearchQuery: () => { },
});

export const SearchContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [searchQuery, setSearchQuery] = useState('');

    return (
        <SearchContext.Provider value={{ searchQuery, setSearchQuery }}>
            {children}
        </SearchContext.Provider>
    );
};

export default SearchContext;
